import { getProfileRoute } from 'constants/helper';

export default class Source {
  constructor() {
    this.id = null;
    this.image = null;
    this.text = '';
    this.type = null;
  }

  // source is an object of Source model
  fromProps({ id, type, image, text }) {
    this.id = id;
    this.type = type;
    this.text = text;
    this.image = image;
  }

  fromJSON(json) {
    const { text } = json;
    const { type } = json;
    const id = json.uuid;
    const { image } = json;
    this.fromProps({ text, id, type, image });
  }

  getUrl() {
    if (!this.type || !this.id) {
      return null;
    }
    switch (this.type) {
      case 'EMPLOYEE':
        return getProfileRoute(this.id);
      default:
        return null;
    }
  }
}
